export { TextFunnel } from './TextFunnel'
